import React, { useEffect } from 'react';
import { HeroSection } from './components/HeroSection';
import { PainPoints } from './components/PainPoints';
import { ProductIntro } from './components/ProductIntro';
import { WhatsIncluded } from './components/WhatsIncluded';
import { WhoItsFor } from './components/WhoItsFor';
import { ThreeSteps } from './components/ThreeSteps';
import { BonusSection } from './components/BonusSection';
import { PricingBundle } from './components/PricingBundle';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { ContactSection } from './components/ContactSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { initMetaPixel, trackEvent } from './utils/metaPixel';
export function App() {
  // Initialize Meta Pixel on mount
  useEffect(() => {
    initMetaPixel();
  }, []);
  // Track ViewContent when key sections become visible
  useEffect(() => {
    const trackedSections = new Set<string>();
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const sectionId = entry.target.getAttribute('data-track-section');
          if (sectionId && !trackedSections.has(sectionId)) {
            trackedSections.add(sectionId);
            trackEvent('ViewContent', {
              content_name: sectionId,
              content_type: 'landing_page_section'
            });
          }
        }
      });
    }, {
      threshold: 0.3
    });
    // Observe trackable sections after a short delay to ensure DOM is ready
    const timer = setTimeout(() => {
      document.querySelectorAll('[data-track-section]').forEach(el => {
        observer.observe(el);
      });
    }, 500);
    return () => {
      clearTimeout(timer);
      observer.disconnect();
    };
  }, []);
  return <div className="min-h-screen font-nunito text-gray-800 bg-light-pink selection:bg-pink-400 selection:text-white" data-id="element-0">
      <HeroSection data-id="element-1" />
      <PainPoints data-id="element-2" />
      <div data-track-section="ProductIntro" data-id="element-3">
        <ProductIntro data-id="element-4" />
      </div>
      <WhatsIncluded data-id="element-5" />
      <WhoItsFor data-id="element-6" />
      <ThreeSteps data-id="element-7" />
      <BonusSection data-id="element-8" />
      <div data-track-section="Pricing" data-id="element-9">
        <PricingBundle data-id="element-10" />
      </div>
      <div data-track-section="Testimonials" data-id="element-11">
        <Testimonials data-id="element-12" />
      </div>
      <FAQ data-id="element-13" />
      <ContactSection data-id="element-14" />
      <FinalCTA data-id="element-15" />
      <Footer data-id="element-16" />
    </div>;
}